module.exports = __webpack_public_path__ + "static/media/sonate-pacifique.84311424.jpg";